<template>
  <div
    class="aiz-card-box border border-light rounded hov-shadow-md mt-1 mb-2 has-transition bg-white"
  >
    <div class="position-relative">
      <a class="d-block">
<!--        :src="getFileViewUrl(item.pic) + '_tn'"-->

        <img
          :alt="$t(item.name)"
          :src="getFileViewUrl(item.pic)"
          class="img-fit2 mx-auto h-140px h-md-210px ls-is-cached lazyloaded"
          @click="jump(productUrl(item.id, item.shopId))"
        />
      </a>
      <div class="absolute-top-right aiz-p-hov-icon">
        <a
          :title="$t('添加到愿望清单')"
          href="javascript:void(0)"
          @click.stop="addToWishList"
        >
          <i class="la la-heart-o"></i>
        </a>
        <a
          :title="$t('加入对比')"
          href="javascript:void(0)"
          @click.stop="addToCompare"
        >
          <i class="las la-sync"></i>
        </a>
        <a
          :title="$t('添加到购物车')"
          href="javascript:void(0)"
          @click.stop="addToCart"
        >
          <i class="las la-shopping-cart"></i>
        </a>
      </div>
    </div>
    <div class="p-md-3 p-2 text-left">
      <div class="fs-15">
        <span class="fw-700 text-primary">{{ formatMoney(priceDiscount(item)) }}</span>
        <span v-if="isSeckill && item.buyDiscount && 100!==item.buyDiscount" class="ml-2" style="text-decoration: line-through;font-size: 12px;">{{ formatMoney(item.price) }}</span>
      </div>
      <StarsComp :star="item.stars" />
      <h3 class="fw-600 fs-13 text-truncate-2 lh-1-4 mb-0 h-35px">
        <a class="d-block text-reset">{{ $t(item.name) }}</a>
      </h3>
    </div>
  </div>
</template>
<script>
import StarsComp from "@/components/StarsComp.vue";

export default {
  props: {
    item: Object,
    // 是否限时秒杀商品
    isSeckill: {
      type: Boolean,
      default: () => false
    }
  },
  components: { StarsComp },
  methods: {
    addToWishList() {
      this.$store
        .dispatch("user/addToWishList", {
          goodsId: this.item.id,
          number: 1,
          shopId: this.item.shopId
        })
        .then(() => {
          this.$toast.success(this.$t("物品已添加到愿望清单"));
        });
    },
    addToCompare() {
      this.$store
        .dispatch("user/addToCompareList", {
          goodsId: this.item.id,
          number: 1,
          shopId: this.item.shopId
        })
        .then(() => {
          this.$toast.success(this.$t("物品已添加到比较列表"));
        });
    },
    addToCart() {
      this.gotToProduct(this.item.id, this.item.shopId);
    },
    priceDiscount(goods) {
      if (!this.isSeckill) return goods.price
      let buyDiscount = goods && goods.buyDiscount || 100;
      return goods && goods.price * buyDiscount / 100
    },
  }
};
</script>
